export default __webpack_public_path__ + "static/scsjptHover-57f586d0be521a91aac251df66f1209b.png";